<template>
  <div v-if="snackbar.showing" class="text-center ma-2">
    <v-snackbar
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :right="snackbar.right"
      :left="snackbar.left"
      :top="snackbar.top"
      :bottom="snackbar.bottom"
      multi-line
    >
      <b v-html="snackbar.text"></b>

      <template v-slot:action="{ attrs }">
        <v-btn text icon small v-bind="attrs" @click="snackbar.showing = false">
          <v-icon>mdi-close-circle </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Snackbar",
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
  },
};
</script>
